import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import {
	contact_us,
	support,
	questionsAndSuggestions
} from "../images";
import { TABLET_SIZE } from "../constants/variables";

class TopSection extends Component {
	constructor() {
		super();
		this.state = {
			desktopMode: {
				text: 'سوالات و پیشنهادات',
				link: '/'
			}
		}
	}
	updateElementText() {
		const that = this;
		if (window.outerWidth <= TABLET_SIZE) {
			that.setState({
				desktopMode: {
					text: "پرسش های متداول",
					link: "/faq"
				}
			});
		} else {
			that.setState({
				desktopMode: {
					text: "سوالات و پیشنهادات",
					link: "/contactus"
				}
			});
		}
	}
	componentWillMount() {
		this.updateElementText();
	}
	componentDidMount() {
		window.addEventListener( "resize", this.updateElementText.bind(this) );
	}
	render() {
		return (
			<div className="container mt-xl-5 pt-5 last-section-main-container">
				<div className="row justify-content-center last-section-title-container">
					<div className="col-xs-6 border-bottom border-bottom-last-section">
						<h2 className="text-center">هنوز موفق نشده اید پاسخ خود را بیابید؟</h2>
					</div>
				</div>
				<div className="row mt-5 justify-content-center last-section-circle-container">
					<div className="col-lg-3 col-md-6 text-center last-section-item-container">
						<Link to="/contactus">
							<div className="last-section-circle">
								<img src={contact_us} alt="ارتباط با ما"/>
							</div>
							<div className="pt-3">
								<p className="font-weight-bold last-section-item-text">ارتباط با ما</p>
							</div>
						</Link>
					</div>
					<div className="col-lg-3 col-md-6 text-center last-section-item-container">
						<Link to="/contactus">
							<div className="last-section-circle">
								<img src={support} alt="پشتیبانی فنی"/>
							</div>
							<div className="pt-3">
								<p className="font-weight-bold last-section-item-text">پشتیبانی فنی</p>
							</div>
						</Link>
					</div>
					<div className="col-lg-3 col-md-6 text-center last-section-item-container">
						<Link to={this.state.desktopMode.link}>
							<div className="last-section-circle">
								<img src={questionsAndSuggestions} alt={this.state.desktopMode.text}/>
							</div>
							<div className="pt-3">
								<p className="font-weight-bold last-section-item-text">{this.state.desktopMode.text}</p>
							</div>
						</Link>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(TopSection);